// Cockpit V-B4 stage tag. The header carries ONE bright stage word that names
// where the deal is in plain broker language: SHOP → PRESENT → BIND → PAPER →
// SERVICE. Derived from the server-computed lifecycle state (never a CRM stage
// read). Terminal states (lost/cancelled/expired) return isTerminal so the
// caller falls back to the muted StageBadge instead of a bright word.
const WORD_BY_STATE = {
  prospect: 'SHOP',
  shopping: 'SHOP',
  presented: 'PRESENT',
  binding: 'BIND',
  bound: 'PAPER',
  placed: 'SERVICE',
  distributed: 'SERVICE',
};

const TERMINAL = new Set(['lost', 'cancelled', 'expired']);

export function stageWord(lifecycleState) {
  if (!lifecycleState) return { word: null, isTerminal: false };
  if (TERMINAL.has(lifecycleState)) return { word: null, isTerminal: true };
  return { word: WORD_BY_STATE[lifecycleState] || null, isTerminal: false };
}
